export default __webpack_public_path__ + "static/media/phoneInTalk_black.61d49272.svg";